import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Layout,
  Menu,
  Modal,
  Radio,
  Mentions,
  Form,
  Input,
  Select,
  Row,
  Col,
  Avatar,
  Dropdown,
  Button,
  Badge,
  Drawer,
} from "antd";
import {
  AndroidFilled,
  LogoutOutlined,
  HomeOutlined,
  SettingOutlined,
  CloudServerOutlined,
  DashboardOutlined,
  AppstoreAddOutlined,
  TableOutlined,
  FolderOutlined,
  TagOutlined,
  CloseCircleOutlined,
  DownOutlined,
  AppstoreOutlined,
  LeftOutlined,
  RightOutlined,
  UsergroupDeleteOutlined,
  ClockCircleOutlined,
  CustomerServiceOutlined,
  UserOutlined,
  BellOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import AddApps from "../components/AddApps";
import AddBoardGroup from "../components/BoardGoups/AddBoardGroup";
import AccMenu from "../components/AccMenu";
import MaterialDesignIcon from "../components/common/MaterialDesignIcon";
import { getBoardsAsync, getGroupsAsync, updateSelectedBoard } from "../redux/boardSlice";
import { addDashboardConfig } from "../redux/editorSlice";
import { getAppsAsync, setOtherUsers, signout } from "../redux/userSlice";
import jwt from "jsonwebtoken";
import WitMegReportingLogo from "../assets/Images/witmeg-reporting.png";
import "./dashbrd.css";
import { ReactComponent as Book } from "../assets/icons/book.svg";
import { ReactComponent as Resource } from "../assets/icons/box.svg";
import { ReactComponent as Schedule } from "../assets/icons/clock.svg";
import { ReactComponent as Users } from "../assets/icons/users.svg";
import { ReactComponent as Home } from "../assets/icons/home.svg";
import { ReactComponent as LogOut } from "../assets/icons/log-out.svg";
import { ReactComponent as DropdownIcon } from "../assets/icons/ic_arrow_drop_down.svg";
const { REACT_APP_OrgRegistryApi, REACT_APP_OrgjwtAud, REACT_APP_OrgjwtIss, REACT_APP_OrgjwtPrivate } = process.env;
const { Header, Sider, Content } = Layout;
const { Option } = Mentions;
const ORG_LIST = [
  {
    OrganisationID: "5eb537c660c090232c0d807b",
    Name: "Best Foods Whole Sale1",
  },
  {
    OrganisationID: "5ec3c4c72ca923bd5e8a6640",
    Name: "South Harrow Food and Wine",
  },
  {
    OrganisationID: "5ec5f702dcd86fe64a959475",
    Name: "Ecologital12",
  },
  {
    OrganisationID: "5ec5f81bdcd86fe64a95947e",
    Name: "Ecologital123",
  },
  {
    OrganisationID: "5ec5f96cdcd86fe64a959486",
    Name: "Ecologital1122",
  },
  {
    OrganisationID: "5ed9b1661be0ae9b446d5bcd",
    Name: "Best Foods New",
  },
  {
    OrganisationID: "5ed9c0181be0ae9b446d5bd4",
    Name: "Ecologital",
  },
  {
    OrganisationID: "5ed9d1ac1be0ae9b446d5be1",
    Name: "Ecologital12258",
  },
  {
    OrganisationID: "5ed9d4661be0ae9b446d5be9",
    Name: "Ecologital223",
  },
  {
    OrganisationID: "5ed9d5911be0ae9b446d5bf1",
    Name: "Ecologital12345",
  },
  {
    OrganisationID: "5ed9d5db1be0ae9b446d5bf9",
    Name: "Ecologital333",
  },
  {
    OrganisationID: "5ed9e6831be0ae9b446d5c01",
    Name: "KRISHNA CASH AND CARRY",
  },
  {
    OrganisationID: "5f005e18abbc59fbdd589a33",
    Name: "Select Super Market - West Croydon",
  },
  {
    OrganisationID: "5f006023abbc59fbdd589a3b",
    Name: "Mini Super Store",
  },
  {
    OrganisationID: "5f0061a0abbc59fbdd589a43",
    Name: "T and O Store",
  },
  {
    OrganisationID: "5f006250abbc59fbdd589a4b",
    Name: "Clark Store",
  },
  {
    OrganisationID: "5f0435c247913a61cc420a28",
    Name: "Ecologital Dev",
  },
  {
    OrganisationID: "5f05e7f454a5908787dccee8",
    Name: "Ecologital Dev Payment",
  },
  {
    OrganisationID: "5f05e81156c85fb55f80f759",
    Name: "Ecologital Dev Payment2",
  },
  {
    OrganisationID: "5f19647bc70bf4bf64c0f37b",
    Name: "Shankar-Retail",
  },
  {
    OrganisationID: "5f19683fc70bf4bf64c0f383",
    Name: "Bestfoods Whole Sale",
  },
  {
    OrganisationID: "5f4f334754a5908787dccf09",
    Name: "Test",
  },
  {
    OrganisationID: "5f58962fdf41239122095743",
    Name: "Suren Pvt Ltd",
  },
  {
    OrganisationID: "5f59e004df4123912209574b",
    Name: "Testq",
  },
  {
    OrganisationID: "5f59e3d9df41239122095753",
    Name: "Ecologital_npos",
  },
  {
    OrganisationID: "5f59f61adf4123912209575b",
    Name: "Ssueen",
  },
  {
    OrganisationID: "5f8985ffdf41239122095763",
    Name: "Casipillai",
  },
  {
    OrganisationID: "5f9113f9df4123912209576b",
    Name: "Ecologital NPOS",
  },
];
const APP_LIST = [
  {
    id: "1",
    name: "Web Order",
    description: "This app is for web ordering for Restaurants",
    url: "https://aharamuthal.com/",
    image: "https://cdn-icons-png.flaticon.com/512/2921/2921822.png",
  },
  {
    id: "2",
    name: "NeutriPOS",
    description: "This app is for Restaurants",
    url: "https://neutripos.witmeg.com/",
    image: "https://cdn-icons-png.flaticon.com/128/948/948036.png",
  },
  {
    id: "3",
    name: "ElectriPOS",
    description: "This app is for Retail",
    url: "https://electripos.witmeg.com",
    image: "https://cdn-icons-png.flaticon.com/512/2921/2921816.png",
  },
  {
    id: "4",
    name: "Neurolage",
    description: "This app is for Whole Sale",
    url: "https://neurolage.witmeg.com",
    image: "https://cdn-icons-png.flaticon.com/128/4003/4003691.png",
  },
  {
    id: "5",
    name: "TempleTrack",
    description: "This app is for Temples",
    url: "https://templetrack.witmeg.com/",
    image: "https://cdn-icons-png.flaticon.com/512/2921/2921818.png",
  },
  {
    id: "6",
    name: "Retailpacx",
    description: "This app is for E Commerce",
    url: "https://retailpacx.witmeg.com",
    image: "https://cdn-icons-png.flaticon.com/128/1162/1162499.png",
  },
  {
    id: "7",
    name: "Loyalty",
    description: "This app is for Everyone",
    url: "https://loyalty.witmeg.com/",
    image: "https://cdn-icons-png.flaticon.com/512/2921/2921821.png",
  },
];
class DashboardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      visible: false,
      sharedListShow: true,
      rtype: "",
      dashboardName: "",
      boardNamerror: false,
      users: [],
      usersList: [],
      userIdList: [],
      sharedOrgIdList: [],
      addedApps: false,
      isLoadingApps: true,
      isAppsMultiSelectEnabled: true,
      appList: [],
      groupMenuVissible: false,
      selectedGoup: null,
      goupError: false,
      selectedSubGoupId: "none",
      isGroupModalVisible: false,
      collapsed: false,
      notificationVisible: false,
      dashboardsDrawerVisible: false,
      notifications: [
        {
          id: 1,
          type: "success",
          title: "Report Generated",
          message: "Your monthly sales report has been generated successfully",
          time: "5 minutes ago",
          read: false,
        },
        {
          id: 2,
          type: "warning",
          title: "Dashboard Update",
          message: "Dashboard 'Q4 Analytics' has been updated by John Doe",
          time: "1 hour ago",
          read: false,
        },
        {
          id: 3,
          type: "info",
          title: "New User Added",
          message: "Sarah Smith has been added to your organization",
          time: "2 hours ago",
          read: true,
        },
        {
          id: 4,
          type: "error",
          title: "Scheduled Report Failed",
          message: "The scheduled report 'Weekly Summary' failed to generate",
          time: "3 hours ago",
          read: false,
        },
        {
          id: 5,
          type: "info",
          title: "System Maintenance",
          message: "Scheduled maintenance on Oct 15, 2025 from 2:00 AM - 4:00 AM",
          time: "1 day ago",
          read: true,
        },
      ],
    };
    this.addBoardGroupRef = createRef();
  }
  // Toggle notification dropdown
  toggleNotification = (visible) => {
    this.setState({ notificationVisible: visible });
  };
  // Mark notification as read
  markAsRead = (id) => {
    this.setState({
      notifications: this.state.notifications.map((notif) => (notif.id === id ? { ...notif, read: true } : notif)),
    });
  };
  // Mark all as read
  markAllAsRead = () => {
    this.setState({
      notifications: this.state.notifications.map((notif) => ({ ...notif, read: true })),
    });
  };
  getCurrentMenuKey = () => {
    const path = this.props.location.pathname;
    if (path === "/" || path === "/home") return ["home"];
    if (path === "/groups") return ["groups"];
    if (path === "/resources") return ["resources"];
    if (path === "/scheduling") return ["schedule"];
    if (path === "/add-resource") return ["resource"];
    // if (path === "/support-page") return ["support"];
    // if (path === "/settings-page") return ["settings"];
    return ["home"]; // default
  };
  GetUserDetails = async (UserDetails) => {
    const timestamp = Math.floor(Date.now() / 1000) + 1000;
    var payload = {
      aud: REACT_APP_OrgjwtAud,
      exp: timestamp,
      iss: REACT_APP_OrgjwtIss,
      usertoken: localStorage.getItem("accessToken"),
    };
    var signOptions = {
      algorithm: "RS256",
    };
    var privateKey = REACT_APP_OrgjwtPrivate;
    var token = jwt.sign(payload, privateKey.replace(/\\n/g, "\n"), signOptions);
    const result = [];
    const requestOptions2 = {
      method: "POST",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ` + token,
      },
      body: JSON.stringify({
        UserID: UserDetails.UserID,
      }),
    };
    return await fetch(REACT_APP_OrgRegistryApi + "v1/permission/org/user/userid", requestOptions2)
      .then((response) => response.json())
      .then((data) => {
        if (data.Status) {
          result.push({ ...UserDetails, UserDetails: data.Result[0] });
        }
        return result[0];
      })
      .catch((error) => {
        //window.location.href="/login/logout"
      });
  };
  componentDidMount() {
    this.props.getBoards(this.props.accessToken);
    this.props.getGroups(this.props.accessToken);
    const timestamp = Math.floor(Date.now() / 1000) + 1000;
    var payload = {
      aud: REACT_APP_OrgjwtAud,
      exp: timestamp,
      iss: REACT_APP_OrgjwtIss,
      usertoken: localStorage.getItem("accessToken"),
    };
    var signOptions = {
      algorithm: "RS256",
    };
    var privateKey = REACT_APP_OrgjwtPrivate;
    var token = jwt.sign(payload, privateKey.replace(/\\n/g, "\n"), signOptions);
    const vrequestOptions = {
      method: "GET",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `Bearer ` + token,
      },
    };
    fetch(`${REACT_APP_OrgRegistryApi}registeredusers/` + localStorage.getItem("orgID"), vrequestOptions)
      .then((lresponse) => lresponse.json())
      .then(async (odata) => {
        const users = await Promise.all(
          odata.Result.map(async (UserID) => await this.GetUserDetails(UserID, odata.Result))
        );
        let validUsers = users.filter((u) => u);
        this.setState({ users: validUsers });
        this.props.setOtherUsers(validUsers);
        console.log(users);
      });
    this.props.getApps();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.accessToken !== this.props.accessToken) {
      this.props.getBoards(this.props.accessToken);
      this.props.getGroups(this.props.accessToken);
    }
  }
  handleLogOut = () => {
    this.props.logOut();
    this.props.history.push("/");
  };
  showModal = (type) => {
    this.setState({
      visible: true,
      value: 1,
      rtype: type,
    });
  };
  handleOk = (e) => {
    if (this.state.dashboardName === "") {
      this.setState({
        boardNamerror: true,
      });
    } else if (!this.state.selectedGoup) {
      this.setState({
        goupError: true,
      });
      return;
    } else {
      this.setState({
        visible: false,
      });
      const configData = {
        boardType: this.state.rtype,
        boardName: this.state.dashboardName,
        isPuplic: this.state.sharedListShow,
        isGlobal: this.state.value === 3,
        shareWith: this.state.sharedListShow ? this.state.userIdList : [],
        appList: this.state.appList,
        groupId: this.state.selectedGoup.id,
        selectedSubGoupId: this.state.selectedSubGoupId,
      };
      localStorage.setItem("currentDashboardConfig", JSON.stringify(configData));
      this.props.setDashboardConfig(configData);
      if (this.state.rtype === "reports") {
        this.props.history.push("/editor/reports");
      } else {
        this.props.history.push("/editor/dashboard");
      }
    }
  };
  handleCancel = () => {
    this.setState({ visible: false });
  };
  onChangeRadio = (e) => {
    console.log(e.target.value);
    if (e.target.value === 2) {
      this.setState({
        sharedListShow: false,
        value: 2,
      });
    } else if (e.target.value === 3) {
      this.setState({
        sharedListShow: false,
        value: 3,
      });
    } else {
      this.setState({
        sharedListShow: true,
        value: 1,
      });
    }
  };
  onSelectSharableUsers = (e) => {
    let users = [...this.state.usersList];
    users.push(e.value);
    this.setState({
      usersList: [...new Set(users)],
    });
    let userIds = [...this.state.userIdList];
    userIds.push(e.data.UserDetails.UserID);
    this.setState({
      userIdList: [...new Set(userIds)],
    });
  };
  onSelectSharableOrganizations = (e) => {
    let orgs = [...this.state.sharedOrgIdList];
    orgs.push(e.value);
    this.setState({ sharedOrgIdList: [...new Set(orgs)] });
  };
  onClickSharableOrganizations = (orgObj) => {
    console.log("onClickSharableOrganizations===>>", orgObj);
    let orgs = [...this.state.sharedOrgIdList];
    orgs.push(orgObj.OrganisationID);
    this.setState({
      sharedOrgIdList: [...new Set(orgs)],
    });
  };
  handleFinishSelectApps = (apps) => {
    this.setState({ appList: apps, addedApps: apps.length > 0 });
  };
  onChangeGoupSearch = (value) => {
    this.setState({
      selectedGoup: [...(this.props.dashboardGroups || []), ...(this.props.reportGroups || [])].find(
        (gd) => gd.id === value
      ),
      goupError: false,
    });
  };
  handleAddGroup = () => {
    this.setState({ isGroupModalVisible: true });
  };
  handleAddResource = () => {
    this.props.history.push("/add-resource");
  };
  handleAddDashboard = (boardType) => {
    this.showModal(boardType);
  };
  handleOkGpModal = () => {
    this.setState({ isGroupModalVisible: false });
  };
  handleCancelGpModal = () => {
    if (this.addBoardGroupRef.current && this.addBoardGroupRef.current.resetToInitialState) {
      this.addBoardGroupRef.current.resetToInitialState();
    }
    this.setState({ isGroupModalVisible: false });
  };
  handleAppSelect = (app) => {
    if (app && app.url) {
      if (/^https?:\/\//.test(app.url)) {
        window.open(app.url, "_blank");
      } else {
        this.props.history.push(app.url);
      }
    }
  };
  // Toggle sidebar collapse
  toggleCollapsed = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };
  // Toggle dashboards drawer
  toggleDashboardsDrawer = () => {
    this.setState({ dashboardsDrawerVisible: !this.state.dashboardsDrawerVisible });
  };
  render() {
    const user = JSON.parse(localStorage.getItem("fullUserDetails") || "{}");
    const avatarValue = user.FirstName ? user.FirstName.charAt(0) + user.LastName.charAt(0) : "U";
    const apps = this.props.apps || [];
    // Get unread notification count
    const unreadCount = this.state.notifications.filter((n) => !n.read).length;
    const getNotificationIcon = (type) => {
      switch (type) {
        case "success":
          return <CheckCircleOutlined style={{ color: "#52c41a" }} />;
        case "warning":
          return <ExclamationCircleOutlined style={{ color: "#faad14" }} />;
        case "error":
          return <CloseCircleOutlined style={{ color: "#ff4d4f" }} />;
        case "info":
        default:
          return <InfoCircleOutlined style={{ color: "#1890ff" }} />;
      }
    };
    const notificationMenu = (
      <div
        style={{
          width: 380,
          maxHeight: 500,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          background: "#fff",
          border: "1px solid #dfdfdfff",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "16px 20px",
            borderBottom: "1px solid #f0f0f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#ffff",
          }}
        >
          <span style={{ fontWeight: 600, fontSize: 16 }}>Notifications</span>
          {unreadCount > 0 && (
            <Button type="link" size="small" onClick={this.markAllAsRead}>
              Mark all as read
            </Button>
          )}
        </div>
        {/* Notifications List */}
        <div style={{ maxHeight: 400, overflowY: "auto" }}>
          {this.state.notifications.length === 0 ? (
            <div style={{ padding: 40, textAlign: "center", color: "#8c8c8c" }}>
              <BellOutlined style={{ fontSize: 48, marginBottom: 16 }} />
              <div>No notifications</div>
            </div>
          ) : (
            this.state.notifications.map((notification) => (
              <div
                key={notification.id}
                onClick={() => this.markAsRead(notification.id)}
                style={{
                  padding: "12px 20px",
                  borderBottom: "1px solid #f0f0f0",
                  cursor: "pointer",
                  backgroundColor: notification.read ? "#fff" : "#f6f9ff",
                  transition: "background-color 0.3s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f5ff")}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = notification.read ? "#fff" : "#f6f9ff")}
              >
                <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
                  <div style={{ fontSize: 20, marginTop: 2 }}>{getNotificationIcon(notification.type)}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                      <span style={{ fontWeight: 600, fontSize: 14 }}>{notification.title}</span>
                      {!notification.read && (
                        <span
                          style={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            backgroundColor: "#1890ff",
                            display: "inline-block",
                            marginTop: 4,
                          }}
                        />
                      )}
                    </div>
                    <div style={{ fontSize: 13, color: "#595959", marginBottom: 6 }}>{notification.message}</div>
                    <div style={{ fontSize: 12, color: "#8c8c8c" }}>{notification.time}</div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
        {/* Footer */}
        {/* {this.state.notifications.length > 0 && (
          <div
            style={{
              padding: "12px 20px",
              borderTop: "1px solid #f0f0f0",
              textAlign: "center",
              backgroundColor: "#fafafa",
            }}
          >
            <Button type="link" onClick={() => this.toggleNotification(false)}>
              View All Notifications
            </Button>
          </div>
        )} */}
      </div>
    );
    const appMenu = (
      <Menu>
        {APP_LIST.map((app) => (
          <Menu.Item
            key={app.id}
            onClick={() => this.handleAppSelect(app)}
            style={{ minWidth: 260, padding: "8px 16px" }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar src={app.image} size={36} style={{ marginRight: 12 }} />
              <div>
                <div style={{ fontWeight: 600 }}>{app.name}</div>
                <div style={{ fontSize: 12, color: "#888" }}>{app.description}</div>
              </div>
            </div>
          </Menu.Item>
        ))}
      </Menu>
    );
    return (
      <div>
        <Layout style={{ minHeight: "100vh" }}>
          <Sider
            width={220}
            theme="light"
            collapsed={this.state.collapsed}
            collapsedWidth={80}
            onCollapse={this.toggleCollapsed}
            className="custom-sider"
          >
            <div className={`sidebar-header ${this.state.collapsed ? "collapsed" : ""}`}>
              <img src={WitMegReportingLogo} alt="logo" className="sidebar-logo" />
              {!this.state.collapsed && (
                <>
                  <div className="sidebar-subtitle">Report Engine</div>
                </>
              )}
            </div>
            <Menu
              mode="inline"
              selectedKeys={this.getCurrentMenuKey()}
              inlineCollapsed={this.state.collapsed}
              className="main-menu"
            >
              <Menu.Item key="home" icon={<Home />} onClick={() => this.props.history.push("/")}>
                Home
              </Menu.Item>
              <Menu.Item key="dashboards" icon={<Book />} onClick={this.toggleDashboardsDrawer}>
                Dashboards
              </Menu.Item>
              {/* <Menu.SubMenu key="addnew" icon={<AppstoreAddOutlined />} title="Add New">
                <Menu.Item key="group" icon={<TagOutlined />} onClick={this.handleAddGroup}>
                  Group
                </Menu.Item>
                <Menu.Item key="resource" icon={<CloudServerOutlined />} onClick={this.handleAddResource}>
                  Resource
                </Menu.Item>
                <Menu.Item
                  key="dashboard"
                  icon={<DashboardOutlined />}
                  onClick={() => this.handleAddDashboard("dashboard")}
                >
                  Report / Dashboard
                </Menu.Item>
              </Menu.SubMenu> */}
              <Menu.Item key="groups" icon={<Users />} onClick={() => this.props.history.push("/groups")}>
                Groups
              </Menu.Item>
              <Menu.Item key="resources" icon={<Resource />} onClick={() => this.props.history.push("/resources")}>
                Resources
              </Menu.Item>
              <Menu.Item key="schedule" icon={<Schedule />} onClick={() => this.props.history.push("/scheduling")}>
                Report Schedule
              </Menu.Item>
              {/* Bottom Menu */}
              <div className="sidebar-bottom">
                <div className="help-section">HELP</div>
                <Menu
                  mode="inline"
                  className="bottom-menu"
                  inlineCollapsed={this.state.collapsed}
                  selectedKeys={this.getCurrentMenuKey()}
                >
                  <Menu.Item
                    // disabled
                    key="support"
                    icon={<CustomerServiceOutlined />}
                    // onClick={() => this.props.history.push("/support-page")}
                  >
                    Support
                  </Menu.Item>
                  <Menu.Item
                    // disabled
                    key="settings"
                    icon={<SettingOutlined />}
                    // onClick={() => this.props.history.push("/groups")}
                  >
                    Settings
                  </Menu.Item>
                </Menu>
                <div className="logout-section" onClick={this.handleLogOut}>
                  {!this.state.collapsed && <span>Log Out</span>}
                  <LogOut />
                </div>
              </div>
            </Menu>
            {/* Collapse Button */}
            <Button
              className="collapse-button"
              onClick={this.toggleCollapsed}
              icon={this.state.collapsed ? <RightOutlined /> : <LeftOutlined />}
            />
          </Sider>
          <Layout>
            <Header
              style={{
                background: "#fff",
                padding: "0 24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #E8E8E8",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {/* <span style={{ fontWeight: "bold", fontSize: 18 }}>Dynamic Reports</span> */}
                <span style={{ marginLeft: 12, color: "#888" }}>Navigate to Applications</span>
                <Dropdown overlay={appMenu} trigger={["click"]} placement="bottomLeft">
                  <Button
                    style={{
                      marginLeft: 24,
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    className="apps-dropdown"
                  >
                    Apps
                    <span style={{ marginLeft: "1rem", marginTop: "8px" }}>
                      <DropdownIcon />
                    </span>
                  </Button>
                </Dropdown>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                {/* Notification Icon */}
                {/* Notification Icon with Dropdown */}
                <Dropdown
                  overlay={notificationMenu}
                  // trigger={["click"]}
                  visible={this.state.notificationVisible}
                  // onVisibleChange={this.toggleNotification}
                  placement="bottomRight"
                >
                  <Badge count={unreadCount} offset={[-2, 2]}>
                    <BellOutlined
                      style={{
                        fontSize: "20px",
                        color: "#595959",
                        cursor: "pointer",
                        transition: "color 0.3s",
                      }}
                      onMouseEnter={(e) => (e.target.style.color = "#1890ff")}
                      onMouseLeave={(e) => (e.target.style.color = "#595959")}
                    />
                  </Badge>
                </Dropdown>
                {/* User Profile Dropdown */}
                <Dropdown
                  overlay={
                    <Menu style={{ minWidth: 200, borderRadius: 8 }}>
                      <Menu.Item key="profile" icon={<UserOutlined />}>
                        Profile
                      </Menu.Item>
                      <Menu.Item key="settings" icon={<SettingOutlined />}>
                        Settings
                      </Menu.Item>
                      <Menu.Divider />
                      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={this.handleLogOut}>
                        Log Out
                      </Menu.Item>
                    </Menu>
                  }
                  trigger={["click"]}
                  placement="bottomRight"
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "4px 12px",
                      borderRadius: "24px",
                      transition: "background-color 0.3s",
                      gap: "10px",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
                  >
                    <Avatar
                      style={{
                        backgroundColor: "#1890ff",
                        fontWeight: 600,
                        fontSize: "14px",
                      }}
                      size={36}
                    >
                      {avatarValue}
                    </Avatar>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                      <span style={{ fontWeight: 600, fontSize: "14px", lineHeight: 1.2 }}>
                        {user.FirstName} {user.LastName}
                      </span>
                      <span style={{ fontSize: "12px", color: "#8c8c8c", lineHeight: 1.2 }}>
                        {user.Email || "user@example.com"}
                      </span>
                    </div>
                    <DownOutlined style={{ fontSize: "10px", color: "#8c8c8c" }} />
                  </div>
                </Dropdown>
              </div>
            </Header>
            <Content style={{ margin: 24, background: "#fff", minHeight: 360 }}>
              {React.isValidElement(this.props.children)
                ? React.cloneElement(this.props.children, {
                    onAddGroup: this.handleAddGroup,
                    onAddResource: this.handleAddResource,
                    onAddDashboard: this.handleAddDashboard,
                  })
                : this.props.children}
            </Content>
          </Layout>
          {/* Create Dashboard/Report Modal */}
          <Modal
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            okText={this.state.rtype === "reports" ? "Create report" : "Create board"}
            okButtonProps={{
              style: {
                display: this.state.addedApps ? "inline-flex" : "none",
              },
            }}
            cancelButtonProps={{
              style: {
                display: this.state.addedApps ? "inline-flex" : "none",
              },
            }}
            width={720}
          >
            {this.state.addedApps ? (
              <>
                <h2>Create new {this.state.rtype === "reports" ? "report" : "board"}</h2>
                <Form.Item
                  name="boardname"
                  rules={[{ required: true, message: "Please input board name!" }]}
                  validateStatus={this.state.boardNamerror ? "error" : ""}
                >
                  <Input
                    placeholder={this.state.rtype === "reports" ? "Report Name" : "Report or Dashboard Name"}
                    value={this.state.dashboardName}
                    onChange={(e) => {
                      this.setState({
                        dashboardName: e.target.value,
                        boardNamerror: false,
                      });
                    }}
                  />
                </Form.Item>
                <Form.Item name="accesstype" rules={[{ required: true, message: "Please select access type!" }]}>
                  <div className="report-radiobtn-container">
                    <Radio.Group onChange={this.onChangeRadio} value={this.state.value}>
                      <Radio value={1}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <MaterialDesignIcon icon="fingerprint" /> <span>Private</span>
                        </div>
                      </Radio>
                      <Radio value={2}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <MaterialDesignIcon icon="groups" />
                          <span>Public</span>
                        </div>
                      </Radio>
                      {localStorage.getItem("IsSpecialUser") === "true" ? (
                        <Radio value={3}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <MaterialDesignIcon icon="public" />
                            <span>&nbsp;Global</span>
                          </div>
                        </Radio>
                      ) : null}
                    </Radio.Group>
                  </div>
                  {this.state.sharedListShow ? (
                    <>
                      <Row>
                        <Col span={6}>
                          <div>Organization</div>
                        </Col>
                        <Col span={18}>
                          <Mentions style={{ width: "100%" }} id="users" onSelect={this.onSelectSharableOrganizations}>
                            {ORG_LIST.map((org) => (
                              <Option
                                data={org}
                                value={org.Name}
                                key={org.OrganisationID}
                                onClick={() => this.onClickSharableOrganizations(org)}
                              >
                                {org.Name}
                              </Option>
                            ))}
                          </Mentions>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={6}>
                          <div>Organization</div>
                        </Col>
                        <Col span={6}>
                          <div>
                            <Input placeholder="small size" prefix={<CloseCircleOutlined fill="#ddd" />} />
                          </div>
                        </Col>
                        <Col span={6}>
                          <div>
                            <Select>
                              <Select.Option>Group1</Select.Option>
                              <Select.Option>Group2</Select.Option>
                            </Select>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                </Form.Item>
                {this.state.value === 3 ? (
                  <>
                    <Row>
                      <Col span={6}>
                        <div>Group Name (Required) :</div>
                      </Col>
                      <Col span={18}>
                        <Form.Item
                          name="mainGroupName"
                          rules={[
                            {
                              required: true,
                              message: "Please select goup!",
                            },
                          ]}
                          validateStatus={this.state.goupError ? "error" : ""}
                        >
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select Goup"
                            optionFilterProp="children"
                            onChange={this.onChangeGoupSearch}
                          >
                            {this.state.rtype === "reports"
                              ? (this.props.reportGroups || [])
                                  .filter((r) => r.isGlobal)
                                  .map((dg) => (
                                    <Select.Option key={dg.id} value={dg.id}>
                                      {dg.title}
                                    </Select.Option>
                                  ))
                              : (this.props.dashboardGroups || [])
                                  .filter((r) => r.isGlobal)
                                  .map((dg) => (
                                    <Select.Option key={dg.id} value={dg.id}>
                                      {dg.title}
                                    </Select.Option>
                                  ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    {this.state.selectedGoup &&
                    this.state.selectedGoup.children &&
                    this.state.selectedGoup.children.length > 0 ? (
                      <Row>
                        <Col span={6}>
                          <div>Sub Group Name (Optional) :</div>
                        </Col>
                        <Col span={18}>
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select sub group"
                            optionFilterProp="children"
                            onChange={(val) => this.setState({ selectedSubGoupId: val })}
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            <Select.Option key="no_sub" value="none">
                              None
                            </Select.Option>
                            {this.state.selectedGoup.children.map((c) => (
                              <Select.Option key={c.id} value={c.id}>
                                {c.title}
                              </Select.Option>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                    ) : null}
                  </>
                ) : (
                  <>
                    <Row>
                      <Col span={6}>
                        <div>Group Name (Required) :</div>
                      </Col>
                      <Col span={18}>
                        <Form.Item
                          name="mainGroupName"
                          rules={[
                            {
                              required: true,
                              message: "Please select goup!",
                            },
                          ]}
                          validateStatus={this.state.goupError ? "error" : ""}
                        >
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select Goup"
                            optionFilterProp="children"
                            onChange={this.onChangeGoupSearch}
                          >
                            {this.state.rtype === "reports"
                              ? (this.props.reportGroups || [])
                                  .filter((r) => !r.isGlobal)
                                  .map((dg) => (
                                    <Select.Option key={dg.id} value={dg.id}>
                                      {dg.title}
                                    </Select.Option>
                                  ))
                              : (this.props.dashboardGroups || [])
                                  .filter((r) => !r.isGlobal)
                                  .map((dg) => (
                                    <Select.Option key={dg.id} value={dg.id}>
                                      {dg.title}
                                    </Select.Option>
                                  ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    {this.state.selectedGoup &&
                    this.state.selectedGoup.children &&
                    this.state.selectedGoup.children.length > 0 ? (
                      <Row>
                        <Col span={6}>
                          <div>Sub Group Name (Optional) :</div>
                        </Col>
                        <Col span={18}>
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select sub group"
                            optionFilterProp="children"
                            onChange={(val) => this.setState({ selectedSubGoupId: val })}
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            <Select.Option key="no_sub" value="none">
                              None
                            </Select.Option>
                            {this.state.selectedGoup.children.map((c) => (
                              <Select.Option key={c.id} value={c.id}>
                                {c.title}
                              </Select.Option>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                    ) : null}
                  </>
                )}
              </>
            ) : (
              <>
                <div>
                  <h2>Add Apps</h2>
                </div>
                <div>
                  <AddApps
                    multiSelectEnabled={this.state.isAppsMultiSelectEnabled}
                    onFinishSelect={this.handleFinishSelectApps}
                  />
                </div>
              </>
            )}
          </Modal>
          {/* Add Group Modal */}
          <Modal
            title="Add New Group"
            visible={this.state.isGroupModalVisible}
            onOk={this.handleOkGpModal}
            onCancel={this.handleCancelGpModal}
            footer={null}
            okText="Save Group"
            width={720}
          >
            <AddBoardGroup
              ref={this.addBoardGroupRef}
              users={this.state.users}
              handleCloseModal={this.handleCancelGpModal}
            />
          </Modal>
          {/* Dashboards Drawer */}
          <Drawer
            title="Report / Dashboard"
            placement="left"
            onClose={this.toggleDashboardsDrawer}
            visible={this.state.dashboardsDrawerVisible}
            width={250}
          >
            <div style={{ padding: 16, height: "100%" }}>
              <AccMenu dashboardGroups={this.props.dashboardGroups} dashboardList={this.props.dashboardList} />
            </div>
          </Drawer>
        </Layout>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const { boards, user } = state;
  return {
    boardsStatus: boards.boardsData.boardsStatus,
    dashboardList: boards.boardsData.filter((bd) => bd.configDetails.boardType === "dashboard"),
    reportList: boards.boardsData.filter((bd) => bd.configDetails.boardType === "reports"),
    dashboardGroups: boards.groups
      ? boards.groups
          .filter((gd) => gd.groupType === "dashboard")
          .sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0))
      : null,
    reportGroups: boards.groups
      ? boards.groups
          .filter((gd) => gd.groupType === "report")
          .sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0))
      : null,
    currentAppPermissions: user.currentAppPermissions ? user.currentAppPermissions : [],
    accessToken: user?.user?.accessToken,
    apps: user.apps || [],
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logOut: () => dispatch(signout()),
    setDashboardConfig: (details) => dispatch(addDashboardConfig(details)),
    getBoards: (t) => dispatch(getBoardsAsync(t)),
    addSelectedBoard: (board) => dispatch(updateSelectedBoard(board)),
    getApps: () => dispatch(getAppsAsync()),
    setOtherUsers: (usersList) => dispatch(setOtherUsers(usersList)),
    getGroups: (t) => dispatch(getGroupsAsync(t)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardView));
